<script>
export default {
  name: 'UpdateTime',
  props: {
    dateTime: { type: String, required: true },
    dateServer: { type: String, required: true },
  },
  data() {
    return {
      currentTime: new Date().getTime(),
      serverTime: new Date(this.dateServer).getTime(),
      timeOffset: 0,
      isLoading: false,
    }
  },
  mounted() {
    this.timeOffset = this.serverTime - this.currentTime
    this.interval = setInterval(() => {
      this.isLoading = true
      this.currentTime = new Date().getTime() + this.timeOffset
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    updateTime() {
      let startTime = new Date(this.dateTime).getTime()
      const elapsedMilliseconds = this.currentTime - startTime

      const days = Math.floor(elapsedMilliseconds / (1000 * 60 * 60 * 24))
      const hours = Math.floor(
        (elapsedMilliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      )
      const minutes = Math.floor(
        (elapsedMilliseconds % (1000 * 60 * 60)) / (1000 * 60)
      )
      let timeElapsed = `${hours}h ${minutes}m `
      if (days !== 0) {
        timeElapsed = `${days}d ` + timeElapsed
      }
      return this.isLoading ? timeElapsed : 'Loading...'
    },
  },
}
</script>

<template>
  <i style="color: #222876">
    {{ updateTime() }}
  </i>
</template>
